import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const Preloader = ({ fixed }) => (
    <div className={`preloader-wrap ${fixed ? 'fixed' : ''}`}>
        <div className="preloader">
            <div />
            <div />
            <div>
                <div />
            </div>
            <div>
                <div />
            </div>
        </div>
    </div>
);

Preloader.defaultProps = {
    fixed: false
};

Preloader.propTypes = {
    fixed: PropTypes.bool
};


export default Preloader;
